import React, { useState, useRef } from "react";
// import toast from "react-hot-toast";
import SavedPrescriptionsSelector from "../../components/SavedPrescriptionsSelector";
import auth_service from "../../services/auth_service";

const PrescriptionForm = ({ isSingleVision, handleAddToCart, totalPrice, ca_id }) => {
  const [prescriptionInputMode, setPrescriptionInputMode] = useState(false);
  const [uploadPrescription, setUploadPrescription] = useState(null);
  const [prescriptionFile, setPrescriptionFile] = useState(null);
  const fileInputRef = useRef(null);
  const [hasTwoPD, setHasTwoPD] = useState(false);
  const [prescription, setPrescription] = useState({
    right: { sph: "0", cyl: "0", axis: "0", add: "0" },
    left: { sph: "0", cyl: "0", axis: "0", add: "0" },
    pd: "",
    rightPD: "",
    leftPD: "",
  });
  const [confirmPrescription, setConfirmPrescription] = useState(false);
  const [showSavedPrescriptions, setShowSavedPrescriptions] = useState(false);
  
  // Check if user is logged in
  const isLoggedIn = (() => {
    try {
      auth_service.getAccessTokenData();
      return true;
    } catch (error) {
      return false;
    }
  })();

  const handlePrescriptionInputSelect = () => {
    setPrescriptionInputMode(true);
    setUploadPrescription(false);
    setConfirmPrescription(false);
  };

  const handlePrescriptionChange = (eye, field, value) => {
    setPrescription((prev) => ({
      ...prev,
      [eye]: {
        ...prev[eye],
        [field]: value,
      },
    }));
  };

  const handlePDChange = (value) => {
    setPrescription((prev) => ({
      ...prev,
      pd: value,
    }));
  };

  const handleSinglePDChange = (eye, value) => {
    setPrescription((prev) => ({
      ...prev,
      [`${eye}PD`]: value,
    }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPrescriptionFile(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleSavedPrescriptionSelect = (savedPrescription) => {
    setPrescription(savedPrescription);
    setHasTwoPD(savedPrescription.hasTwoPD);
    setPrescriptionInputMode(true);
    setUploadPrescription(false);
    setConfirmPrescription(false);
    // toast.success("Prescription loaded successfully!", {
    //   duration: 2000,
    //   position: "top-center",
    //   style: {
    //     background: "#10B981",
    //     color: "#fff",
    //   },
    // });
  };

  const handleAddToCartWrapper = () => {
    const prescriptionData = uploadPrescription
      ? { prescriptionFile }
      : {
          right: {
            sph: prescription.right.sph || '0.00',
            cyl: prescription.right.cyl || '0.00',
            axis: prescription.right.axis || '0',
            add: prescription.right.add || '0.00',
          },
          left: {
            sph: prescription.left.sph || '0.00',
            cyl: prescription.left.cyl || '0.00',
            axis: prescription.left.axis || '0',
            add: prescription.left.add || '0.00',
          },
          pd: prescription.pd || '',
          rightPD: prescription.rightPD || '',
          leftPD: prescription.leftPD || '',
          hasTwoPD: hasTwoPD,
        };

    handleAddToCart(prescriptionData, confirmPrescription, uploadPrescription);
  };

  const isAddToCartDisabled =
    uploadPrescription === null ||
    (uploadPrescription === true && !prescriptionFile) ||
    (uploadPrescription === false && !confirmPrescription);

  const isAddToCartDisabledOnInputPage = !confirmPrescription;

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 p-4 text-white"
           style={{ background: 'linear-gradient(to right, #1F509A, #000066)' }}>
        <h2 className="text-lg font-bold flex items-center gap-2">
          <div className="w-6 h-6 bg-amber-500 rounded-full flex items-center justify-center">
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          Add Your Prescription
        </h2>
        <p className="text-blue-100 text-xs mt-1">Choose how you'd like to provide your prescription details</p>
      </div>

      <div className="p-4 space-y-4">
        {!prescriptionInputMode && (
          <div className="space-y-3">
            <div className="grid gap-3">
              <button
                onClick={handlePrescriptionInputSelect}
                className={`group relative flex items-center gap-3 p-3 rounded-lg border-2 transition-all duration-300 hover:shadow-md ${
                  uploadPrescription === false
                    ? "border-blue-900 bg-blue-50 shadow-sm"
                    : "border-gray-200 hover:border-amber-300"
                }`}
                style={{ 
                  borderColor: uploadPrescription === false ? '#1F509A' : undefined,
                  backgroundColor: uploadPrescription === false ? 'rgba(0, 0, 122, 0.05)' : undefined
                }}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-400 to-orange-500 rounded-full text-white flex-shrink-0 group-hover:scale-105 transition-transform duration-300">
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <div className="flex-grow text-left">
                  <h3 className="text-sm font-bold text-gray-800 group-hover:text-blue-900 transition-colors">
                    Input Prescription Values
                  </h3>
                  <p className="text-xs text-gray-600 mt-0.5">
                    Manually enter each prescription value for precise fitting
                  </p>
                </div>
                {uploadPrescription === false && (
                  <div className="text-blue-900" style={{ color: '#1F509A' }}>
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                )}
              </button>

              <button
                onClick={() => setUploadPrescription(true)}
                className={`group relative flex items-center gap-3 p-3 rounded-lg border-2 transition-all duration-300 hover:shadow-md ${
                  uploadPrescription === true
                    ? "border-blue-900 bg-blue-50 shadow-sm"
                    : "border-gray-200 hover:border-amber-300"
                }`}
                style={{ 
                  borderColor: uploadPrescription === true ? '#1F509A' : undefined,
                  backgroundColor: uploadPrescription === true ? 'rgba(0, 0, 122, 0.05)' : undefined
                }}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-400 to-orange-500 rounded-full text-white flex-shrink-0 group-hover:scale-105 transition-transform duration-300">
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                    />
                  </svg>
                </div>
                <div className="flex-grow text-left">
                  <h3 className="text-sm font-bold text-gray-800 group-hover:text-blue-900 transition-colors">
                    Upload Prescription Photo
                  </h3>
                  <p className="text-xs text-gray-600 mt-0.5">
                    Quick and easy if you have a photo ready
                  </p>
                </div>
                {uploadPrescription === true && (
                  <div className="text-blue-900" style={{ color: '#1F509A' }}>
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                )}
              </button>

              {/* Saved Prescriptions Option */}
              {isLoggedIn && (
                <button
                  onClick={() => setShowSavedPrescriptions(true)}
                  className="group relative flex items-center gap-3 p-3 rounded-lg border-2 border-gray-200 hover:border-green-300 transition-all duration-300 hover:shadow-md"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-green-400 to-green-500 rounded-full text-white flex-shrink-0 group-hover:scale-105 transition-transform duration-300">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  </div>
                  <div className="flex-grow text-left">
                    <h3 className="text-sm font-bold text-gray-800 group-hover:text-green-700 transition-colors">
                      Use Saved Prescription
                    </h3>
                    <p className="text-xs text-gray-600 mt-0.5">
                      Select from your previously saved prescriptions
                    </p>
                  </div>
                  <div className="text-green-600">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </button>
              )}
            </div>

            {uploadPrescription === true && (
              <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4">
                <div className="text-center">
                  <div 
                    onClick={triggerFileInput}
                    className="group cursor-pointer inline-flex flex-col items-center justify-center w-full max-w-md mx-auto p-4 border-2 border-dashed border-amber-300 rounded-lg hover:border-amber-400 hover:bg-amber-50 transition-all duration-300"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mb-2 group-hover:scale-105 transition-transform duration-300">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                    </div>
                    <h4 className="text-sm font-semibold text-gray-800 mb-1">
                      {prescriptionFile ? 'Change File' : 'Choose Prescription Image'}
                    </h4>
                    <p className="text-xs text-gray-600 mb-2 max-w-xs">
                      Click to select an image of your prescription from your device
                    </p>
                    <div className="bg-white px-3 py-1 rounded-md border border-amber-300 group-hover:bg-amber-50 transition-colors">
                      <span className="text-xs font-medium text-gray-700">
                        {prescriptionFile ? prescriptionFile.name : "No file selected"}
                      </span>
                    </div>
                  </div>
                  
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    className="hidden"
                    accept="image/*"
                  />

                  {prescriptionFile && (
                    <div className="mt-4">
                      <button
                        onClick={() => setConfirmPrescription(true)}
                        className="inline-flex items-center gap-1 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        Use This Prescription
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {prescriptionInputMode && (
          <div className="space-y-4">
            {/* Right Eye Section */}
           <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4">
  <div className="flex items-center gap-2 mb-3">
    <div className="w-8 h-8 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full flex items-center justify-center text-white font-bold"
         style={{ backgroundColor: '#1F509A' }}>
      R
    </div>
    <h3 className="text-base font-bold text-gray-800">Right Eye (OD)</h3>
  </div>
  
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
    {/* SPH Field */}
    <div>
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        SPH <span className="text-gray-400">(Sphere)</span>
      </label>
      <input
        type="number"
        step="0.25"
        className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-900 bg-white text-center font-medium"
        style={{ focusBorderColor: '#1F509A' }}
        value={prescription.right.sph}
        onChange={(e) => handlePrescriptionChange("right", "sph", e.target.value)}
        placeholder="0.00"
      />
    </div>

    {/* CYL Field */}
    <div>
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        CYL <span className="text-gray-400">(Cylinder)</span>
      </label>
      <input
        type="number"
        step="0.25"
        className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-900 bg-white text-center font-medium"
        style={{ focusBorderColor: '#1F509A' }}
        value={prescription.right.cyl}
        onChange={(e) => handlePrescriptionChange("right", "cyl", e.target.value)}
        placeholder="0.00"
      />
    </div>

    {/* Axis Field */}
    <div>
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        Axis <span className="text-gray-400">(0-180)</span>
      </label>
      <input
        type="number"
        min="0"
        max="180"
        className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-900 bg-white text-center font-medium"
        style={{ focusBorderColor: '#1F509A' }}
        value={prescription.right.axis}
        onChange={(e) => handlePrescriptionChange("right", "axis", e.target.value)}
        placeholder="0"
      />
    </div>

    {/* ADD Field - Conditionally shown */}
    {!isSingleVision ? (
      <div>
        <label className="block text-xs font-semibold text-gray-700 mb-1">
          ADD <span className="text-gray-400">(Addition)</span>
        </label>
        <input
          type="number"
          step="0.25"
          className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-900 bg-white text-center font-medium"
          style={{ focusBorderColor: '#1F509A' }}
          value={prescription.right.add}
          onChange={(e) => handlePrescriptionChange("right", "add", e.target.value)}
          placeholder="0.00"
        />
      </div>
    ) : (
      <div className="hidden sm:block"></div> )}
  </div>
</div>

            {/* Left Eye Section */}
           <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
  <div className="flex items-center gap-2 mb-3">
    <div className="w-8 h-8 bg-gradient-to-br from-green-600 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold">
      L
    </div>
    <h3 className="text-base font-bold text-gray-800">Left Eye (OS)</h3>
  </div>
  
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
    {/* SPH Field */}
    <div>
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        SPH <span className="text-gray-400">(Sphere)</span>
      </label>
      <input
        type="number"
        step="0.25"
        className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-600 bg-white text-center font-medium"
        value={prescription.left.sph}
        onChange={(e) => handlePrescriptionChange("left", "sph", e.target.value)}
        placeholder="0.00"
      />
    </div>

    {/* CYL Field */}
    <div>
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        CYL <span className="text-gray-400">(Cylinder)</span>
      </label>
      <input
        type="number"
        step="0.25"
        className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-600 bg-white text-center font-medium"
        value={prescription.left.cyl}
        onChange={(e) => handlePrescriptionChange("left", "cyl", e.target.value)}
        placeholder="0.00"
      />
    </div>

    {/* Axis Field */}
    <div>
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        Axis <span className="text-gray-400">(0-180)</span>
      </label>
      <input
        type="number"
        min="0"
        max="180"
        className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-600 bg-white text-center font-medium"
        value={prescription.left.axis}
        onChange={(e) => handlePrescriptionChange("left", "axis", e.target.value)}
        placeholder="0"
      />
    </div>

    {/* ADD Field - Conditionally shown */}
    {!isSingleVision ? (
      <div>
        <label className="block text-xs font-semibold text-gray-700 mb-1">
          ADD <span className="text-gray-400">(Addition)</span>
        </label>
        <input
          type="number"
          step="0.25"
          className="w-full px-2 py-2 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-600 bg-white text-center font-medium"
          value={prescription.left.add}
          onChange={(e) => handlePrescriptionChange("left", "add", e.target.value)}
          placeholder="0.00"
        />
      </div>
    ) : (
      <div className="hidden sm:block"></div> 
    )}
  </div>
</div>

            {/* PD Section */}
            {ca_id !== 3 && (
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                  PD
                </div>
                <h3 className="text-base font-bold text-gray-800">Pupillary Distance</h3>
              </div>

              <div className="mb-4">
                <label className="flex items-start gap-2 cursor-pointer group">
                  <div className="relative">
                    <input
                      type="checkbox"
                      checked={hasTwoPD}
                      onChange={() => setHasTwoPD(!hasTwoPD)}
                      className="sr-only"
                    />
                    <div className={`w-5 h-5 rounded-md border-2 transition-all duration-200 ${
                      hasTwoPD 
                        ? 'bg-blue-900 border-blue-900' 
                        : 'border-gray-300 group-hover:border-amber-400'
                    }`}
                         style={{ backgroundColor: hasTwoPD ? '#1F509A' : undefined, borderColor: hasTwoPD ? '#1F509A' : undefined }}>
                      {hasTwoPD && (
                        <svg className="w-3 h-3 text-white mt-0.5 ml-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-gray-800 block">
                      My prescription has two separate PD values
                    </span>
                    <span className="text-2xs text-gray-600">
                      Some prescriptions list separate PD values for each eye
                    </span>
                  </div>
                </label>
              </div>

              {hasTwoPD ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Right PD <span className="text-gray-400">(mm)</span>
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-amber-500 bg-white text-center font-medium transition-all duration-200"
                      value={prescription.rightPD}
                      onChange={(e) =>
                        handleSinglePDChange("right", e.target.value)
                      }
                      placeholder="Right PD"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Left PD <span className="text-gray-400">(mm)</span>
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-amber-500 bg-white text-center font-medium transition-all duration-200"
                      value={prescription.leftPD}
                      onChange={(e) =>
                        handleSinglePDChange("left", e.target.value)
                      }
                      placeholder="Left PD"
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    Pupillary Distance <span className="text-gray-400">(mm, optional)</span>
                  </label>
                  <div className="w-full sm:w-1/2">
                    <input
                      type="number"
                      className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-amber-500 bg-white text-center font-medium transition-all duration-200"
                      value={prescription.pd}
                      onChange={(e) => handlePDChange(e.target.value)}
                      placeholder="Enter PD value"
                    />
                  </div>
                </div>
              )}
            </div>
            )}

            {/* Confirmation Section */}
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <label className="flex items-start gap-3 cursor-pointer group">
                <div className="relative">
                  <input
                    type="checkbox"
                    checked={confirmPrescription}
                    onChange={() => setConfirmPrescription(!confirmPrescription)}
                    className="sr-only"
                  />
                  <div className={`w-5 h-5 rounded-md border-2 transition-all duration-200 ${
                    confirmPrescription 
                      ? 'bg-blue-900 border-blue-900' 
                      : 'border-gray-300 group-hover:border-blue-500'
                  }`}
                       style={{ backgroundColor: confirmPrescription ? '#1F509A' : undefined, borderColor: confirmPrescription ? '#1F509A' : undefined }}>
                    {confirmPrescription && (
                      <svg className="w-3 h-3 text-white mt-0.5 ml-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>
                </div>
                <div>
                  <span className="text-xs font-semibold text-gray-800 block leading-relaxed">
                    I confirm that this information is correct and taken from a valid prescription.
                  </span>
                  <span className="text-2xs text-gray-600">
                    Please double-check all values before proceeding
                  </span>
                </div>
              </label>
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="bg-gray-50 border-t border-gray-200 p-4">
          {!prescriptionInputMode && (
            <div className="mb-3">
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-gray-700">Total Price:</span>
                <span className="text-lg font-bold bg-gradient-to-r from-blue-900 to-amber-600 bg-clip-text text-transparent">
                  ₹{totalPrice}
                </span>
              </div>
            </div>
          )}
          <button
            onClick={handleAddToCartWrapper}
            disabled={prescriptionInputMode ? isAddToCartDisabledOnInputPage : isAddToCartDisabled}
            className={`w-full py-3 rounded-lg font-semibold text-base transition-all duration-200 flex items-center justify-center gap-1 ${
              (prescriptionInputMode ? isAddToCartDisabledOnInputPage : isAddToCartDisabled)
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-gradient-to-r from-blue-900 to-blue-800 text-white hover:from-blue-800 hover:to-blue-700 shadow-md hover:shadow-lg hover:scale-[1.02]"
            }`}
            style={{ 
              background: !(prescriptionInputMode ? isAddToCartDisabledOnInputPage : isAddToCartDisabled) 
                ? 'linear-gradient(to right, #1F509A, #000066)' 
                : undefined 
            }}
          >
            <svg className="w-5 h-5 text-amber-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m0 0H17M9 19.5h.01M20 19.5h.01" />
            </svg>
            Add to Cart
          </button>
        </div>
      </div>
      
      {/* Saved Prescriptions Modal */}
      <SavedPrescriptionsSelector
        isOpen={showSavedPrescriptions}
        onClose={() => setShowSavedPrescriptions(false)}
        onSelectPrescription={handleSavedPrescriptionSelect}
      />
    </div>
  );
};

export default PrescriptionForm;